import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'

import style from './style/zaptic-team-badge-style'
import { getIcon } from './helpers/icons'

@customElement('zaptic-team-badge')
export class TeamBadge extends LitElement {
    static styles = style

    @property({ type: String })
    name = ''

    @property({ type: Boolean })
    faded = false

    @property({ type: Boolean })
    heavy = true

    @property({ type: Boolean })
    smallIcon = false

    render() {
        return html`
            <div
                class="icon ${classMap({
                    faded: this.faded,
                    small: this.smallIcon,
                })}"
            >
                ${getIcon('team')}
            </div>
            <zaptic-ellipsis class="name ${classMap({ heavy: this.heavy })}">${this.name}</zaptic-ellipsis>
        `
    }
}
